import MainContactanos from "../components/contactanos/MainContactanos";

function Contactanos() {
    return (
			<MainContactanos/>
		);
}

export default Contactanos;